import { ScheduledOperationStatusEnum } from "./scheduleOperationStatus.enum";

export function getEnumValueFromString(enumKey: string): ScheduledOperationStatusEnum | undefined {
    if (enumKey in ScheduledOperationStatusEnum) {
        return ScheduledOperationStatusEnum[enumKey as keyof typeof ScheduledOperationStatusEnum];
    }
    return undefined;
}